export const GET_NOTIFICATIONS_ALL = '/notifications/all'
